import answerAPI from "../../api/answer"
import { getItem, setItem } from "../../plugins/localStorage"

const state = {
  history: []
}

const getters = {}

const actions = {
  undo({ state, dispatch, commit }) {
    let undoCount = 0
    for (let [index, { method, args }] of state.history.entries()) {
      switch (method) {
        case "restoreDeletedAnswers":
          dispatch("answers/restoreAnswers", args.answers, { root: true })
          commit("undo", index - undoCount)
          undoCount++
        break
      }
    }
  }
}

const mutations = {
  addDeletedAnswers(state, { answers }) {
    const deletedHistoryIndex = state.history.findIndex(h => h.method === "restoreDeletedAnswers")
    if (deletedHistoryIndex !== -1) {
      state.history[deletedHistoryIndex].args = {
        answers: answers,
      }
      return
    }

    state.history.unshift({
      method: "restoreDeletedAnswers",
      args: {
        answers: answers,
      },
    })
  },

  undo(state, index) {
    state.history.splice(index, 1)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
